export const isProduction = !(/localhost|192/.test(window.location.href))
export const http = isProduction ? 'https://' : ''
export const domain = isProduction ? 'admin.lemazzxc.com' : ''
export const host = `${http}${domain}/api`

/** 链家地图 sug 代理路径前缀（与 nginx / setupProxy 中 /lianjia-map-proxy 一致） */
export const lianjiaMapSugProxyPrefix =
  process.env.REACT_APP_LIANJIA_MAP_PROXY_PREFIX || '/lianjia-map-proxy'

export const cacheKeys = {
  token: 'TOKEN_CACHE',
  admin: 'ADMIN_CACHE',
  isSuper: 'IS_SUPER_CACHE',
  loginPhone: 'LOGIN_PHONE',
  loginPassword: 'LOGIN_PASSWORD',
  operationLastShopInfo: 'OPERATION_LAST_SHOP_INFO',
  materialLastShopInfo: 'MATERIAL_LAST_SHOP_INFO',
}

// 团购平台类型
export const tuanPlatformType = [
  {
    label: '全部',
    value: 0
  },
  {
    label: '美团',
    value: 1
  },
  {
    label: '高德',
    value: 2
  },
  {
    label: '抖音',
    value: 3
  }
]

// 退款原因
export const refundReason = [
  {
    label: '不在附近',
    value: 1
  },
  {
    label: '设备故障',
    value: 2
  },
  {
    label: '下次再充值',
    value: 3
  },
  {
    label: '洗车体验不太好',
    value: 4
  },
  {
    label: '排队太久',
    value: 5
  },
  {
    label: '其他原因',
    value: 6
  }
]

// 订单退款状态
export const refundStatus = ['未退款', '退款中', '已退款']
// 用户状态
export const userBlacklistStatus = ['正常', '拉黑']

// 用户评价星级
export const starList = [
  { 'id': '1', 'name': '1星' }, { 'id': '2', 'name': '2星' },
  { 'id': '3', 'name': '3星' }, { 'id': '4', 'name': '4星' },
  { 'id': '5', 'name': '5星' },
]

// 跨店消费：转入=其他店余额在本店花掉；转出=本店余额在其他店花掉
export const orderTransferFilter = [
  { id: 'in', name: '跨店转入' },
  { id: 'out', name: '跨店转出' },
]

// 付款渠道：1美团 2高德 3抖音；balance=余额启动（非团购核销）
export const orderPayChannelFilter = [
  { id: '1', name: '美团' },
  { id: '2', name: '高德' },
  { id: '3', name: '抖音' },
  { id: 'balance', name: '余额启动' },
]

// 搜索历史记录数
export const maxSearchHistory = 5;

// 售后类型，1：泡沫冲洗不干净，2：不出泡沫，3：喷枪/水管漏水，4：没喷头，5：吸尘堵塞，6：错按结算，7：不出镀膜，8：其它
export const afterSaleType = [
  {
    label: '泡沫冲洗不干净',
    value: 1
  },
  {
    label: '不出泡沫',
    value: 2
  },
  {
    label: '喷枪/水管漏水',
    value: 3
  },
  {
    label: '没喷头',
    value: 4
  },
  {
    label: '吸尘堵塞',
    value: 5
  },
  {
    label: '错按结算',
    value: 6
  },
  {
    label: '不出镀膜',
    value: 7
  },
  {
    label: '其它',
    value: 8
  }
]

// 运营对账类型，1：美团结算，2：抖音结算，3：高德结算，4：租金，5：水费，6：电费，7：推广成本，8：维护成本
export const SuperOperationType = [
  {
    label: '美团结算',
    value: 1
  },
  {
    label: '抖音结算',
    value: 2
  },
  {
    label: '高德结算',
    value: 3
  },
  {
    label: '租金',
    value: 4
  },
  {
    label: '水费',
    value: 5
  },
  {
    label: '电费',
    value: 6
  },
  {
    label: '推广成本',
    value: 7
  },
  {
    label: '保洁费',
    value: 8
  }
]

// 运营对账类型，1：美团结算，2：抖音结算，3：高德结算，4：租金，5：水费，6：电费，7：推广成本，8：维护成本
export const OperationType = [
  {
    label: '租金',
    value: 4
  },
  {
    label: '水费',
    value: 5
  },
  {
    label: '电费',
    value: 6
  }
]

// 核销状态，1：已核销，2：已使用，3：已撤销
export const ReceiptStatus = [
  {
    label: '已核销，未使用',
    value: 1
  },
  {
    label: '已使用',
    value: 2
  },
  {
    label: '已撤销',
    value: 3
  }
]

// 发券类型，1：自动，2：管理员，3：用户
export const TicketType = [
  {
    label: '自动',
    value: 1
  },
  {
    label: '管理员',
    value: 2
  },
  {
    label: '用户',
    value: 3
  }
]

/** 管理员账号手机号：大陆 11 位，或香港 8 位（可带 852 区号） */
export const ADMIN_PHONE_PATTERN = /^(1[3-9]\d{9}|[4-9]\d{7}|852[4-9]\d{7})$/

// 管理员类型
export const AdminType = [
  {
    label: '管理员',
    value: 1
  },
  {
    label: '加盟商',
    value: 2
  },
  {
    label: '运营',
    value: 3
  },
  {
    label: '物业',
    value: 4
  }
]

// 文明洗车处罚类型
export const CivilizedPenaltyType = [
  { label: '警告', value: 1 },
  { label: '罚款10元', value: 2 },
  { label: '罚款20元', value: 3 },
  { label: '罚款50元', value: 4 },
]

export function civilizedPenaltyTypeLabel(type?: number) {
  const item = CivilizedPenaltyType.find(i => i.value === type)
  return item?.label || '-'
}

// 城市名称
export const CityName = [
  {
    label: '深圳',
    value: 'shenzhen'
  },
  {
    label: '东莞',
    value: 'dongguan'
  }
]

// 店铺状态
export const StatusType = [
  {
    label: '规划中',
    value: '1',
    color: 'gren',
  },
  {
    label: '筹备中',
    value: '2',
    color: 'yellow',
  },
  {
    label: '洽谈中',
    value: '3',
    color: 'blue',
  },
  {
    label: '已开店',
    value: '4',
    color: 'red',
  }
]

// 发券类型
export const couponValue = [
  {
    label: '1小时免停券',
    value: '1',
  },
  {
    label: '2小时免停券',
    value: '2',
  }
]

// 范围选项
export const RangeOptions = [
  { label: '1公里', value: 1 },
  { label: '2公里', value: 2 },
  { label: '3公里', value: 3 },
  { label: '6公里', value: 6 }
]